import apiClient from '../../../services/apiClient';

export const validateGroupEasyLink = (prefix: string, groupCode: string) => {
  return apiClient.get(`/v1/easy-link/${prefix}/${groupCode}`);
};
